export default __webpack_public_path__ + "static/media/nexwell-power-logo.5d433d5d.svg";